import React from "react";
import { Animated, Easing } from "react-native";
import { connect, } from '~/redux/connect';
import { getSearchFilterByModelId, getSearchFilterValue, } from "~/stateGetter";
import { Box, Button, Divider, ClipView, Icon,  } from "~/native-ui";
import { Filter } from "~/ui/Fields/VariadicField/VariadicField";
import { withResponsiveFlags } from "../../hoc/withResponsiveProps";



class SearchFilter extends React.PureComponent {
    state = {
        filterShown: false,
    }

    filterRef = React.createRef(null);

    animationProps = {
        style: { position: "absolute", zIndex: 100, top: 0, left: 0, right: 0, paddingTop: 2 },
        animation: new Animated.Value(0),
        outputRange: [
            `inset(30px calc(100% - 30px) 30px 30px)`,
            `inset(0px calc(0% - 0px) 0px 0px)`,
        ],
    }

    get canToggle () {
        return this.props.isXS;
    }

    setFilterRef = (node) => {
        this.filterRef.current = node;
    }

    animate (toValue) {
        return Animated.timing(this.animationProps.animation, {
            toValue: toValue === 1,
            useNativeDriver: true,
            easing: toValue ? Easing.exp : Easing.circle,
            isInteraction: true,
            duration: toValue ? 200 : 150,
        });
    }

    toggleFilterDisplay = () => {
        if (!this.canToggle) return;

        const filterShown = !this.state.filterShown;
        

        this.animate(Number(filterShown)).start(() => {
            if (!filterShown) return
            this.filterRef.current?.focus()
        });

        this.setState({ filterShown });
    }

    onBlurSearchInput = () => {
        this.toggleFilterDisplay()
    }


    getFilterProps() {
        const floatingFilterProps = !this.canToggle  ? {
            iconRight: <Icon type="search" size="xs" mr="2" />,
        } : {
            onBlur: this.onBlurSearchInput,
            iconRight: <Button variant="primary-outline" label={this.props.trans("close")} mr="2" />,
        }


        return {
            title: "",
            variant: "rounded",
            isVariadicFilter: false,
            modelId: this.props.modelId,
            name: this.props.modelSearchFilter,
            placeholder: this.props.trans("searchPlaceholder"),
            autoComplete: "off",
            ref: this.setFilterRef,
            ...floatingFilterProps
        }
    }


    badgeProps = {
        height: "2",
        width: "2",
        top: 0,
        right: 0,
        backgroundColor: "red.500"
    }
    renderFilterWithToggle () {
        return (
            <>
                <Button badge={this.props.isSearchFilterApplied} onPress={this.toggleFilterDisplay} color="muted.900" ghost mt="0" rounded="20" icon="search" badgeProps={this.badgeProps} />
                <ClipView {...this.animationProps}>
                    <Box backgroundColor="muted.200" width="100%" px="3" py="10px">
                        <Filter { ...this.getFilterProps() } />
                    </Box>
                </ClipView>
                <Divider orientation="vertical" bg="coolGray.300" h="5" mx="2" ml="4" />
            </>
        )
    }


    renderFilter() {
        return (
            <>
                <Filter { ...this.getFilterProps() } />
                <Divider orientation="vertical" bg="coolGray.300" h="5" mx="2" ml="4" />
            </>
        )
    }

    render() {
        if (!this.props.modelSearchFilter) {
            return null;
        }

        return this.canToggle ? this.renderFilterWithToggle() : this.renderFilter()
    }
}


const mapStateToProps = (state, { modelId }) => {
    const modelSearchFilter = getSearchFilterByModelId(state, modelId),
          filterValue = getSearchFilterValue(state, modelId),
          isSearchFilterApplied = !!filterValue?.trim();

    return {
        modelSearchFilter,
        isSearchFilterApplied,
    }
}


export default connect(mapStateToProps)(withResponsiveFlags(SearchFilter, { includeKeys: ['isXS'] }))